const MetricType = Object.freeze({
  ALERTS: 'ALERTS',
  RESP: 'RESP',
  CALLS: 'CALLS',
  APDEX: 'APDEX',
  ERROR: 'ERROR',
  USERS: 'USERS',
  CRASHES: 'CRASHES',
  CPU: 'CPU',
  RAM: 'RAM',
  STORAGE: 'STORAGE',
  NETWORK: 'NETWORK',
  NAME: 'NAME',
  AVAILABILITY: 'AVAILABILITY',
});

const ScopeType = Object.freeze({
  SERVICE: 'Service',
});

const Capability = Object.freeze({
  APM: 'APM',
  BROWSER: 'Browser',
  VM: 'VM',
  DATABASE: 'Database',
  MOBILE: 'Mobile',
  WSM: 'WSM',
  SM: 'Synthetic',
  K8M: 'K8M',
  LOG: 'LOG',
  ANALYTICS: 'ANALYTICS',
  CLOUD: 'CAPABILITY_CLOUD',
});

export { MetricType, ScopeType, Capability };
